
import {
  ref,
  watch,
  onMounted,
  defineComponent,
  computed,
  useContext,
} from '@nuxtjs/composition-api';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ProductPreviewSliderFractions from '~/domains/product/components/ProductPreviewSliderFractions';

export default defineComponent({
  name: 'ProductPreviewSlider',
  components: {
    UILightbox: () => import('~/components/ui/UILightbox'),
    ProductPreviewSliderFractions,
    Swiper,
    SwiperSlide,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { $config } = useContext();
    const swiperImage = ref(null);
    const swiperThumbs = ref(null);
    const activeIndex = ref(0);
    const isSliderThumbsInit = ref(false);
    const isSliderImagesInit = ref(false);
    const activeVariation = ref(0);
    const visibleLightbox = ref(false);

    const similarProducts = computed(() =>
      props?.product?.similar_products?.[0].items.map((item) => ({
        ...item,
        slug: `/product/${item.slug}`,
      }))
    );

    const imagesForLightbox = computed(() => {
      if (!props.product) {
        return [];
      }

      return props.product.variations[activeVariation.value].images.map(
        (image) => `${$config.imageApiUrl}${image}`
      );
    });

    const swiperImageOptions = {
      slidesPerView: 1,
      pagination: {
        el: '.fractions',
        clickable: true,
        type: 'fraction',
        formatFractionCurrent: (index) => {
          return `0${index}`;
        },
        formatFractionTotal: (index) => {
          return `0${index}`;
        },
      },
      breakpoints: {
        640: {
          allowTouchMove: false,
          direction: 'vertical',
        },
      },
      on: {
        /* eslint-disable */
        init: function () {
          isSliderImagesInit.value = true;
        },
        /* eslint-enable */
      },
    };

    const swiperThumbsOptions = {
      spaceBetween: 20,
      slidesPerView: 3,
      threshold: 3,
      direction: 'vertical',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        /* eslint-disable */
        click: function () {
          if (!Number.isInteger(this.clickedIndex)) return;
          activeIndex.value = this.clickedIndex;
        },
        init: function () {
          isSliderThumbsInit.value = true;
        },
        /* eslint-enable */
      },
    };

    const setSlideByIndex = (swiper, index) => {
      swiper.slideTo(index);
    };

    const prevSlide = () => {
      swiperImage.value.$swiper.slidePrev();
    };

    const nextSlide = () => {
      swiperImage.value.$swiper.slideNext();
    };

    onMounted(() => {
      const $swiperImage = swiperImage.value.$swiper;
      $swiperImage.on('slideChange', () => {
        activeIndex.value = $swiperImage.realIndex;
      });
    });

    watch(activeIndex, (to) => {
      setSlideByIndex(swiperImage.value.$swiper, to);
    });

    return {
      activeVariation,
      similarProducts,
      isSliderImagesInit,
      isSliderThumbsInit,
      activeIndex,
      swiperImage,
      swiperThumbs,
      swiperImageOptions,
      swiperThumbsOptions,
      visibleLightbox,
      imagesForLightbox,
      prevSlide,
      nextSlide,
      setSlideByIndex,
    };
  },
});
